import { render } from "./IconInsertDriveFile.vue?vue&type=template&id=9a5e14da"
import script from "./IconInsertDriveFile.vue?vue&type=script&lang=js"
export * from "./IconInsertDriveFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__